// extracted by mini-css-extract-plugin
module.exports = {"cardBody":"Issue_cardBody__1uY74","badge":"Issue_badge__1Fp7j"};